import React from "react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useMemo } from "react";

ChartJS.register(ArcElement, Tooltip, Legend);
const PiceChart = ({ dataChart, listColor, height, width }) => {
  const data = {
    datasets: [
      {
        data: dataChart,
        backgroundColor: listColor,
        labels: [],
        // labelSuffix: "%",
        borderWidth: 0,
        pointStyle: "circle",
      },
    ],
  };
  const options = {
    cutout: 25,
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          return ctx.chart.data.labels[ctx.dataIndex] + ": " + value + "%";
        },
        color: "#fff",
      },
    },
  };
  return (
    <div style={{ height, width }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};
export default PiceChart;
